import { bffAuthRequest } from "../../shared/api/bff-auth-request";

import { Profile, User } from "./types";

interface SendOtpRequest {
  phone: string;
}

export const sendOtp = (data: SendOtpRequest) =>
  bffAuthRequest.post("/renter-auth/send-otp", data);

interface LoginRequest {
  phone: string;
  code: string;
}

interface LoginResponse {
  accessToken: string;
}

export const login = (data: LoginRequest) =>
  bffAuthRequest.post<LoginResponse>("/renter-auth/login", data);

export const getCurrentUser = () =>
  bffAuthRequest.get<User>("/renter-users/me");

export const getProfile = () =>
  bffAuthRequest.get<Profile>("/renter-users/profile");

interface GetProfilePhotoRequest {
  fileName: string;
}

export const getProfilePhoto = ({ fileName }: GetProfilePhotoRequest) =>
  bffAuthRequest
    .get<Blob>(`/renter-users/file?fileName=${fileName}`, {
      responseType: "blob",
    })
    .then((blob) => URL.createObjectURL(blob))
    .catch(() => "");
